import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
//import {Configuration} from 'src/app/Utilities/configurations';
// var Configuration = require('src/assets/app-config.json');
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { delay } from 'rxjs/operators';
import { configuration } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class AuthorizationService {

  public loggedIn: boolean;

  constructor(private http: HttpClient) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
  }

  userAuthentication(userName, password, delayDuration: number) {
    this.loggedIn = true;
    var data = `username=${encodeURIComponent(userName)}&password=${password}:${sessionStorage.getItem("FacilityId")}&grant_type=password`;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' });
    return this.http.post(configuration.tokenUrl + 'Token', data.toString(), { headers: reqHeader }).pipe(delay(delayDuration));
  }

  getUserDetailsById(id: any): Observable<IUserDetails> {
    return this.http.get<IUserDetails>(
      `${configuration.apiUrl + 'Admin/ById'}?userid=${encodeURIComponent(id)}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  clinicAuthentication(userName, password, delayDuration: number) {
    this.loggedIn = true;
    var data = `username=${encodeURIComponent(userName)}&password=${password}:${sessionStorage.getItem("FacilityId")}&grant_type=password`;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' });
    return this.http.post(configuration.clinicTokenUrl + 'Token', data.toString(), { headers: reqHeader }).pipe(delay(delayDuration));
  }

  billingAuthentication(userName, password, delayDuration: number) {
    this.loggedIn = true;
    var data = `username=${encodeURIComponent(userName)}&password=${password}:${sessionStorage.getItem("FacilityId")}&grant_type=password`;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' });
    return this.http.post(configuration.billingTokenUrl + 'Token', data.toString(), { headers: reqHeader }).pipe(delay(delayDuration));
  }

}
